import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, user, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authLoading && user) {
      navigate("/admin", { replace: true });
    }
  }, [user, authLoading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      // Small delay to let auth context update before navigating
      setTimeout(() => navigate("/admin"), 100);
    } catch (err) {
      const detail = err.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : Array.isArray(detail) ? detail.map(e => e.msg || JSON.stringify(e)).join(" ") : "Login failed";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  if (authLoading) return (
    <div className="min-h-screen bg-[#F4F6FA] flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-[#32A334] border-t-transparent rounded-full animate-spin" />
    </div>
  );

  if (user) return null;

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#F4F6FA] flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white p-10 rounded-lg border border-[#E2E8F0] shadow-sm">
        <div className="text-center mb-10">
          <img src="/logo.png" alt="K10 Properties Group" className="h-16 mx-auto mb-4" />
          <h1 className="font-['DM_Serif_Display'] text-3xl font-semibold text-[#1A1A2E] mb-1">Admin Portal</h1>
          <p className="text-[#94A3B8] text-sm">Sign in to manage properties</p>
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col gap-6" data-testid="login-form">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
            className="bg-white border border-[#E2E8F0] focus:border-[#32A334] text-[#1A1A2E] py-3 px-4 outline-none transition-colors w-full placeholder:text-[#94A3B8] text-sm rounded"
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
            className="bg-white border border-[#E2E8F0] focus:border-[#32A334] text-[#1A1A2E] py-3 px-4 outline-none transition-colors w-full placeholder:text-[#94A3B8] text-sm rounded"
            required
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="bg-[#1C671D] text-white hover:bg-[#145215] transition-colors duration-300 px-8 py-3.5 uppercase tracking-widest text-sm font-semibold disabled:opacity-50 w-full rounded"
          >
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
